import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Card } from '../card';
import translationFallback from '../i18n/translations/en-US/waffles.json';
import { NotificationCard } from '../notification-card';
import { Paragraph } from '../paragraph';
import { ScreenReaderOnly } from '../screen-reader-only';
import { descriptionStaticStyle, titleStaticStyle, toastStaticStyle, } from './styles';
function CardInternal({ description, onClose, size, title, variant, }) {
    const { ready, t } = useTranslation('waffles');
    function renderAnnouncement() {
        switch (variant) {
            case 'success':
                return (_jsx(ScreenReaderOnly, { children: `${ready
                        ? t('Shared.status.success')
                        : translationFallback.Shared.status.success}:` }));
            case 'warning':
                return (_jsx(ScreenReaderOnly, { children: `${ready
                        ? t('Shared.status.warning')
                        : translationFallback.Shared.status.warning}:` }));
            case 'error':
                return (_jsx(ScreenReaderOnly, { children: `${ready
                        ? t('Shared.status.error')
                        : translationFallback.Shared.status.error}:` }));
            default:
                return null;
        }
    }
    return (_jsxs(NotificationCard, Object.assign({ closable: true, css: toastStaticStyle }, { onClose, size, variant }, { children: [_jsxs(Card.Header, Object.assign({ as: "h2", css: titleStaticStyle, size: size }, { children: [renderAnnouncement(), title] })), description != null && (_jsx(Paragraph, Object.assign({ css: descriptionStaticStyle, size: size, variant: "secondary" }, { children: description })))] })));
}
export default CardInternal;
